import React from 'react';

// Theme card with a 3-stripe color swatch (bgCardSolid | accent | accentLight)
// and a labeled name + italic tagline below. Used by the forge's theme picker
// to let the user preview each available theme. Border + glow shift to the
// CURRENT theme's accent when this tile is selected; everything else
// (swatch stripes, label colors, fonts) is drawn from the *themeData* being
// previewed so each tile reads as its own palette.
// Extracted verbatim from prototypes/campaign-creation-prototype.jsx
// lines 1578-1623.
export const ThemePickerTile = ({ themeData, active, onClick, currentTheme }) => {
  const tc = currentTheme.colors;
  const swatch = themeData.colors;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={!!active}
      style={{
        padding: 0,
        border: `2px solid ${active ? tc.accent : tc.borderLight}`,
        borderRadius: 8,
        background: swatch.bgCardSolid,
        cursor: 'pointer',
        overflow: 'hidden',
        textAlign: 'left',
        transition: 'all 150ms ease',
        boxShadow: active ? `0 0 12px ${tc.accentGlow}` : 'none',
        width: '100%',
      }}
    >
      <div style={{ display: 'flex', height: 32 }}>
        <div style={{ flex: 1, background: swatch.bgCardSolid }} />
        <div style={{ flex: 1, background: swatch.accent }} />
        <div style={{ flex: 1, background: swatch.accentLight }} />
      </div>
      <div style={{
        padding: '8px 10px',
        borderTop: `1px solid ${swatch.borderLight}`,
      }}>
        <div style={{
          fontFamily: themeData.typography?.headingFamily,
          fontSize: '0.88rem',
          fontWeight: 600,
          color: swatch.accentLight,
        }}>{themeData.name}</div>
        {themeData.tagline && (
          <div style={{
            fontSize: '0.68rem',
            color: swatch.textMuted,
            fontFamily: themeData.typography?.fontFamily,
            marginTop: 1,
            fontStyle: 'italic',
            lineHeight: 1.3,
          }}>{themeData.tagline}</div>
        )}
      </div>
    </button>
  );
};
